import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "h-width-100p h-height-100p h-flex" }
const _hoisted_2 = { class: "b-calendar-page__calendar_wrapper" }
const _hoisted_3 = { class: "b-calendar-page__logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "b-calendar-page" }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 2,
  class: "h-mv-30"
}
const _hoisted_8 = { class: "b-appointment-main__title h-width-100p h-text-center" }
const _hoisted_9 = { class: "b-calendar-page__body" }
const _hoisted_10 = {
  key: 3,
  class: "b-calendar-page__show-button h-flex-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftBarMenu = _resolveComponent("LeftBarMenu")!
  const _component_FwBurgerIcon = _resolveComponent("FwBurgerIcon")!
  const _component_CalendarDateNavigation = _resolveComponent("CalendarDateNavigation")!
  const _component_CalendarDatePicker = _resolveComponent("CalendarDatePicker")!
  const _component_FwSpinLoader = _resolveComponent("FwSpinLoader")!
  const _component_NoEventPreviewPage = _resolveComponent("NoEventPreviewPage")!
  const _component_UserList = _resolveComponent("UserList")!
  const _component_FwHorizontalScroll = _resolveComponent("FwHorizontalScroll")!
  const _component_PlanTable = _resolveComponent("PlanTable")!
  const _component_PlanTableMonth = _resolveComponent("PlanTableMonth")!
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_ChooseEventPopup = _resolveComponent("ChooseEventPopup")!
  const _component_AddOrEditEventPopup = _resolveComponent("AddOrEditEventPopup")!
  const _component_DeletePopup = _resolveComponent("DeletePopup")!
  const _component_InformationPopup = _resolveComponent("InformationPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showCalendar)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "leftBar",
          class: _normalizeClass(["b-calendar-page__left-bar", { "b-over-fixed-background": _ctx.isFixedBg }])
        }, [
          (_ctx.isMenuOpen)
            ? (_openBlock(), _createBlock(_component_LeftBarMenu, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_FwBurgerIcon, {
              class: "b-calendar-page__burger",
              size: 24,
              isActive: _ctx.isMenuOpen,
              color: _ctx.isMenuOpen ? "#637898" : "#213F6B",
              onToggle: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMenuOpen = !_ctx.isMenuOpen))
            }, null, 8, ["isActive", "color"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: _ctx.requireImage(`${_ctx.mainLogo}.svg`)
              }, null, 8, _hoisted_4)
            ]),
            (_ctx.date)
              ? (_openBlock(), _createBlock(_component_CalendarDateNavigation, {
                  key: 0,
                  date: _ctx.date,
                  menu: _ctx.menu,
                  activeId: _ctx.activeId,
                  onChangeCalendarTypeId: _ctx.changeCalendarTypeId,
                  onChangeDay: _ctx.changeDay
                }, null, 8, ["date", "menu", "activeId", "onChangeCalendarTypeId", "onChangeDay"]))
              : _createCommentVNode("", true),
            _createVNode(_component_CalendarDatePicker, {
              date: _ctx.date,
              eventsSlots: _ctx.filteredEventsSlots,
              onChangeCalendarMonth: _ctx.changeCalendarMonth,
              onUpdateDates: _ctx.updateDatesForce,
              onShowChoosePopup: _ctx.showChoosePopupHandler
            }, null, 8, ["date", "eventsSlots", "onChangeCalendarMonth", "onUpdateDates", "onShowChoosePopup"])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.datesLoading)
        ? (_openBlock(), _createBlock(_component_FwSpinLoader, {
            key: 0,
            colors: ["#27dbbd", "#27DBBD", "#27DBBD"],
            class: "b-global-loading b-global-loading--transparent",
            isActive: _ctx.datesLoading,
            className: "h-p-20"
          }, null, 8, ["isActive"]))
        : _createCommentVNode("", true),
      (_ctx.pageLoading)
        ? (_openBlock(), _createBlock(_component_FwSpinLoader, {
            key: 1,
            colors: ["#27dbbd", "#27DBBD", "#27DBBD"],
            class: "b-global-loading",
            isActive: _ctx.pageLoading,
            className: "h-p-20"
          }, null, 8, ["isActive"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (!_ctx.pageLoading && !_ctx.datesLoading && _ctx.events.length === 0 && _ctx.showNoEventPreview && !_ctx.isEventFirstInitialExist)
              ? (_openBlock(), _createBlock(_component_NoEventPreviewPage, {
                  key: 0,
                  onCloseNoEventPreview: _ctx.closeNoEventPreview,
                  onCreateFirstEventPopup: _ctx.createFirstEventPopup
                }, null, 8, ["onCloseNoEventPreview", "onCreateFirstEventPopup"]))
              : _createCommentVNode("", true),
            (_ctx.showUsersList)
              ? (_openBlock(), _createBlock(_component_FwHorizontalScroll, {
                  key: 1,
                  isPageLoaded: true,
                  style: _normalizeStyle(_ctx.scrollStyle),
                  slotWrapperClass: "h-flex h-flex-dir-column h-height-auto-force",
                  iconClass: "h-opacity-1",
                  newClass: "fw-arrow-big-circle",
                  newClassModifier: "fw-arrow-big-circle--middle-size",
                  arrowBgWidth: null,
                  colorIcon: "#fff",
                  btnLocation: "between"
                }, {
                  content: _withCtx(() => [
                    (!_ctx.pageLoading)
                      ? (_openBlock(), _createBlock(_component_UserList, {
                          key: 0,
                          class: "b-user-list__main--scroll-list",
                          users: _ctx.usersDataByKind,
                          style: _normalizeStyle(_ctx.userListStyle),
                          userFilterIds: _ctx.userFilterIds,
                          onClick: _ctx.addActiveUser
                        }, null, 8, ["users", "style", "userFilterIds", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["style"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t(_ctx.currentMonthName)) + " " + _toDisplayString(_ctx.currentYear), 1)
                ])),
            _createVNode(_component_FwHorizontalScroll, {
              isPageLoaded: true,
              style: _normalizeStyle(_ctx.scrollStyle),
              slotWrapperClass: "h-flex h-flex-dir-column",
              iconClass: "h-opacity-1",
              newClass: "fw-arrow-big-circle",
              wrapperClass: "b-calendar-page__corner-fix",
              arrowBgWidth: null,
              colorIcon: "#fff",
              arrowKey: _ctx.arrowKey,
              btnLocation: "between"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.isWeekType && _ctx.dates.length && !_ctx.datesLoading)
                    ? (_openBlock(), _createBlock(_component_PlanTable, {
                        key: 0,
                        dates: _ctx.dates,
                        events: _ctx.events,
                        users: _ctx.usersDataByKind,
                        userFilterIds: _ctx.userFilterIds,
                        type: _ctx.$route.name,
                        updateKey: _ctx.updateKey,
                        lunchBreakMap: _ctx.lunchBreakMap,
                        whBreakMap: _ctx.whBreakMap,
                        onUpdateAllData: _ctx.updateAllData,
                        onOpenChoosePopup: _ctx.openChoosePopup
                      }, null, 8, ["dates", "events", "users", "userFilterIds", "type", "updateKey", "lunchBreakMap", "whBreakMap", "onUpdateAllData", "onOpenChoosePopup"]))
                    : _createCommentVNode("", true),
                  (_ctx.isMonthType && _ctx.dates.length && !_ctx.datesLoading)
                    ? (_openBlock(), _createBlock(_component_PlanTableMonth, {
                        key: 1,
                        dates: _ctx.dates,
                        events: _ctx.events,
                        users: _ctx.usersDataByKind,
                        date: _ctx.calendarDate,
                        userFilterIds: _ctx.userFilterIds,
                        type: _ctx.$route.name,
                        updateKey: _ctx.updateKey,
                        firstDayOfWeek: _ctx.firstDayOfWeek,
                        calendarYear: _ctx.calendarYear,
                        calendarMonth: _ctx.calendarMonth,
                        onOpenChoosePopup: _ctx.openChoosePopup
                      }, null, 8, ["dates", "events", "users", "date", "userFilterIds", "type", "updateKey", "firstDayOfWeek", "calendarYear", "calendarMonth", "onOpenChoosePopup"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["style", "arrowKey"]),
            (!_ctx.isDesktop())
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_FwButton, {
                    class: "h-mv-5",
                    borderRadiusType: "small-border",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCalendar = !_ctx.showCalendar))
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode(" Show calendar ", -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    (_ctx.showChoosePopup)
      ? (_openBlock(), _createBlock(_component_ChooseEventPopup, {
          key: 1,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showChoosePopup = false)),
          onOpenAddPopup: _ctx.openAddPopup
        }, null, 8, ["onOpenAddPopup"]))
      : _createCommentVNode("", true),
    (_ctx.showAddPopup)
      ? (_openBlock(), _createBlock(_component_AddOrEditEventPopup, {
          key: 2,
          eventType: _ctx.eventType,
          event: _ctx.addEventData,
          loading: _ctx.loading,
          dates: _ctx.dates,
          users: _ctx.usersDataByKind,
          eventUserId: _ctx.addEventUserId,
          date: _ctx.existingDate,
          originValue: _ctx.originValue,
          lunchBreakMap: _ctx.lunchBreakMap,
          whBreakMap: _ctx.whBreakMap,
          onOpenDeletePopup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDeletePopup = true)),
          onUpdateAllData: _ctx.updateAllData,
          onUpdateDate: _ctx.updateDate,
          onClose: _ctx.closeAddOrEditEventPopup
        }, null, 8, ["eventType", "event", "loading", "dates", "users", "eventUserId", "date", "originValue", "lunchBreakMap", "whBreakMap", "onUpdateAllData", "onUpdateDate", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showDeletePopup)
      ? (_openBlock(), _createBlock(_component_DeletePopup, {
          key: 3,
          instance: _ctx.addEventData,
          isRequestSending: _ctx.isDeleteRequestSending,
          onRemoveEvent: _ctx.removeEvent,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDeletePopup = false))
        }, null, 8, ["instance", "isRequestSending", "onRemoveEvent"]))
      : _createCommentVNode("", true),
    (_ctx.isNoAccessPopup && _ctx.eventDataToShow)
      ? (_openBlock(), _createBlock(_component_InformationPopup, {
          key: 4,
          headerText: _ctx.$t(`NO.ACCESS.CALENDAR`),
          bodyText: _ctx.$t(`NO.ACCESS.CALENDAR.ONLY.ADMIN`),
          buttonText: _ctx.$t(`POPUP.FINALY.CLOSE`),
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isNoAccessPopup = false))
        }, null, 8, ["headerText", "bodyText", "buttonText"]))
      : _createCommentVNode("", true)
  ]))
}